<template>
	<sf-data-table
		ref="msgTable"
		paging
		:pageUnit="30"
		:totalSize="groups.totalSize"
		:currentPage="groups.currentPage"
		:columns="dicMsgManagementCols"
		:rows="dicMsgManagements"
		:addRowDatas="addRowDatas"
		:span-method="objectSpanMethod"
		:stripe="false"
		selection
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plus" :onClick="addAction">
				{{ getMessage_('SWCC000007') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('SWCC000327') }}
			</sf-button>
			<sf-button color="error" line v-if="isButton_(scrId, 'CD')" icon="trash" :onClick="deleteAction">
				{{ getMessage_('SWCC000328') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DicMsgManagement/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: [],
			currentTableData: null,
			rowSpanCount: 0
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.dicMsgManagements;
		},
		dicMsgManagementCols() {
			return [
				{
					label: this.getMessage_('SWCC000337'), // 메세지 ID
					prop: 'msgKey',
					minWidth: '150px',
					sortable: false,
					form: {
						type: 'select',
						options: this.gridMsgID,
						isDisabled: this.isDisabled
						// SWCC000355
					}
				},
				{
					label: this.getMessage_('SWCC000341'), // 시스템
					prop: 'msgLoc',
					minWidth: '100px',
					sortable: false,
					form: {
						type: 'select',
						options: this.gridMsgLocs
					}
				},
				{
					label: this.getMessage_('SWCC000340'), // 메시지타입
					prop: 'msgType',
					minWidth: '130px',
					sortable: false,
					form: {
						type: 'select',
						options: this.gridMsgTypes
					}
				},
				{
					label: this.getMessage_('SWCC000339'), // 메시지언어
					prop: 'msgLangDesc',
					minWidth: '140px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000338'), // 메시지내용
					prop: 'msgText',
					minWidth: '300px',
					sortable: false,
					form: {
						type: 'input'
					}
				},
				{
					label: this.getMessage_('SWCC000146'), // 등록일
					prop: 'regDt',
					minWidth: '180px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000005'), // 등록자
					prop: 'regId',
					minWidth: '100px',
					sortable: false
				}
			];
		},
		schema1() {
			return yup.array().of(
				yup.object().shape({
					msgText: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000338')])) //{0}은(는) 팔수 입력 값 입니다. , 메세지내용
				})
			);
		},
		schema2() {
			return yup.array().of(
				yup.object().shape({
					msgType: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000340')])), //{0}은(는) 팔수 입력 값 입니다. , 메세지타입
					msgLoc: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000341')])), //{0}은(는) 팔수 입력 값 입니다. , 시스템
					msgKey: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000337')])) //{0}은(는) 팔수 입력 값 입니다. , 메세지 ID
				})
			);
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		addAction() {
			this.makeAddDatas();
			this.rows.unshift(...this.addRowDatas);
			// console.log(...this.addRowDatas);
			// this.$refs.msgTable.getTable().toggleRowSelection(...this.addRowDatas);
			this.addRowDatas.forEach(row => {
				this.$refs.msgTable.getTable().toggleRowSelection(row);
			});
		},
		saveAction() {
			const selected = this.$refs.msgTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},
		deleteAction() {
			// console.log('@@@@ delete action');
			const selected = this.$refs.msgTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000108'), //삭제하시겠습니까??
				// buttons: [{ title: this.getMessage_('SWCC000328'), clickFn: () => this.save(selected) }], //저장
				buttons: [{ title: this.getMessage_('SWCC000328'), clickFn: () => this.remove() }] //저장
			});

			// console.log('@@@@@@@@@@@@',selected);
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (this.currentTableData || this.currentTableData == null || this.currentTableData != this.$refs.msgTable.getTable().tableData) {
				if (this.currentTableData != null && this.currentTableData.length != this.$refs.msgTable.getTable().tableData.length)
					this.makeAddDatas();
				this.currentTableData = this.$refs.msgTable.getTable().tableData;
			}

			let rowSpanKey = ['userSelect', 'tableState', 'msgKey', 'msgType', 'tmpKey', 'msgLoc'];
			if (
				rowSpanKey.findIndex(item => {
					return item == column.property;
				}) >= 0
			) {
				let spanIndex = 0;
				let rowSpanCount = 0;
				var keyName = 'msgKey';
				if (row.rowType === 'add') {
					keyName = 'tmpKey';
				}

				// checkBox -> change selection
				if (column.property == 'userSelect') {
					this.userSelectionChange(row, keyName);
				}
				// console.log('@@@@ this.currentTableData: ', this.currentTableData);

				let currentKey = this.currentTableData[rowIndex][keyName];
				let prevKey = rowIndex > 0 ? this.currentTableData[rowIndex - 1][keyName] : null;

				if (prevKey != currentKey) {
					rowSpanCount = 1;
					for (let i = rowIndex + 1; i < this.currentTableData.length; i++) {
						// console.log('@@@@ this.currentTableData[i]: ', this.currentTableData[i]);
						if (currentKey == this.currentTableData[i][keyName]) {
							rowSpanCount++;
						} else {
							break;
						}
					}

					spanIndex = rowIndex;
				}

				if (rowIndex == spanIndex) {
					return {
						rowspan: rowSpanCount,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},
		userSelectionChange(paramRow, keyName) {
			let checkIndex = this.$refs.msgTable.multipleSelection.findIndex(ele => ele.tableIndex == paramRow.tableIndex);

			if (paramRow.userSelect && checkIndex < 0) {
				this.currentTableData.forEach(row => {
					if (row[keyName] == paramRow[keyName]) {
						this.$refs.msgTable.multipleSelection.push(row);
					}
				});
			}

			if (paramRow.userSelect === false && checkIndex > -1) {
				this.currentTableData.forEach(row => {
					if (row[keyName] == paramRow[keyName]) {
						this.$refs.msgTable.multipleSelection.splice(checkIndex, 1);
					}
				});
			}
		},
		resetSelection() {
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			// this.$refs.msgTable.initTableData();
			this.$emit('Refresh');
		},
		save(saveRows) {
			try {
				// console.log('@@@@ saveRows:', saveRows);
				// return
				// 유효성 검사
				this.schema1.validateSync(saveRows);
				this.schema2.validateSync([{ ...saveRows[0] }]);

				let sendData = {
					status: 1,
					plantCd: this.searchParams.plantCd,
					data: this.makeSendDataSet()
				};
				// console.log('@@@@ sendData: ', sendData);
				// return

				let requiredKeys = ['msgKey', 'msgType', 'msgLoc', 'msgText'];
				let messages = [];
				for (let i = 0; i < sendData.data.length; i++) {
					for (let j = 0; j < sendData.data[i].length; j++) {
						requiredKeys.forEach(item => {
							if (sendData.data[i][j][item] == undefined || sendData.data[i][j][item] == null || sendData.data[i][j][item] == '') {
								messages.push(item);
							}
						});

						if (messages.length > 0) {
							this.$sf_showMessage({
								title: this.getMessage_('SWCC000415'), //입력 정보를 확인해주세요.
								message: this.getMessage_('SWCC000416') // 메시지ID, 시스템, 메시지타입, 메시지내용 필수 입력.
							});
							break;
						}
					}

					if (messages.length > 0) {
						sendData.data = [];
						break;
					}
				}

				if (sendData.data != undefined && sendData.data.length > 0) {
					this.$sf_toggleLoading(true);
					this.setDicMsgManagement_(sendData)
						.then(value => {
							if (value.message != undefined && value.message != null) {
								this.$sf_toast({
									type: value.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(value.messageCd)
								});
							}
							this.resetTable();
						})
						.catch(error => {
							this.$sf_toast({
								type: 'error',
								message: error.message
							});
							Promise.reject(error);
						})
						.finally(() => {
							this.$sf_toggleLoading(false);
						});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		remove() {
			// console.log('@@@@ delete');
			let sendData = {
				status: 2,
				plantCd: this.searchParams.plantCd,
				data: []
			};

			this.$refs.msgTable.multipleSelection.forEach(row => {
				if (row.msgKey != '') {
					sendData.data.push({
						msgKey: row.msgKey,
						chgId: 'ADMIN'
					});
				}
			});

			this.$sf_toggleLoading(true);
			this.setDicMsgManagement_(sendData)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					// this.$refs.msgTable.deleteHandler(false);
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		saveFunc(saveRows) {},
		makeAddDatas() {
			let randomKey = 'ADD' + (Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000);
			this.addRowDatas = [
				{
					rowType: 'add',
					rnum: '',
					userSelect: true,
					msgKey: '',
					tmpKey: randomKey,
					msgLangDesc: '영어',
					msgLang: 'en_US',
					msgType: '',
					msgText: '',
					useYn: 'Y',
					rgnDt: '',
					rgnId: 'ADMIN'
				},
				{
					rowType: 'add',
					rnum: '',
					msgKey: 'dummy',
					tmpKey: randomKey,
					msgLangDesc: '한국어',
					msgLang: 'ko_KR',
					msgType: 'dummy',
					msgLoc: 'dummy',
					msgText: '',
					useYn: 'Y',
					rgnDt: '',
					rgnId: 'ADMIN'
				},
				{
					rowType: 'add',
					rnum: '',
					msgKey: 'dummy',
					tmpKey: randomKey,
					msgLangDesc: '중국어',
					msgLang: 'zh_CH',
					msgType: 'dummy',
					msgLoc: 'dummy',
					msgText: '',
					useYn: 'Y',
					rgnDt: '',
					rgnId: 'ADMIN'
				}
			];
		},
		makeSendDataSet() {
			let returnDataSet = [];
			let subSet = [];
			let sendKeys = [];
			this.$refs.msgTable.multipleSelection.forEach(row => {
				let keyName = 'msgKey';
				if (row.rowType === 'add') {
					keyName = 'tmpKey';
				}

				if (
					sendKeys.length == 0 ||
					(sendKeys.length > 0 &&
						sendKeys.findIndex(item => {
							return item == row[keyName] && row[keyName] != '';
						}) < 0)
				) {
					sendKeys.push(row[keyName]);
				}
			});

			for (let i = 0; i <= sendKeys.length; i++) {
				this.$refs.msgTable.multipleSelection.forEach(row => {
					let keyName = 'msgKey';
					if (row.rowType === 'add') {
						keyName = 'tmpKey';
					}

					if (sendKeys[i] == row[keyName]) {
						let pushSet = {
							msgKey: row.msgKey,
							msgType: row.msgType,
							msgLoc: row.msgLoc,
							msgLang: row.msgLang,
							msgText: row.msgText,
							regId: 'ADMIN',
							chgId: 'ADMIN'
						};
						['msgKey', 'msgType', 'msgLoc'].forEach(key => {
							if (row[key] == '' || row[key] == undefined) {
								subSet.forEach(item => {
									if (item[key] != '') {
										pushSet[key] = item[key];
									}
								});
							}
						});

						subSet.push(pushSet);

						sendKeys.filter(ele => ele != sendKeys[i]);
					}
				});

				if (subSet.length > 0) {
					returnDataSet.push(subSet);
				}

				subSet = [];
			}

			// console.log('@@@@ returnDataSet:', returnDataSet);
			return returnDataSet;
		},
		saveClick() {
			// if (this.$refs.msgTable.multipleSelection.length < 1) {
			// 	// 입력 정보를 확인해주세요.
			// 	// 메시지ID, 시스템, 메시지타입, 메시지내용 필수 입력.

			// 	this.$showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000434') });
			// 	return;
			// }

			this.$showMessage({
				type: 'confirm',
				message: tjiogetMessage_('SWCC000501'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		deleteClick() {
			if (
				this.$refs.msgTable.multipleSelection.length < 1 ||
				this.$refs.msgTable.multipleSelection.findIndex(ele => ele.tableState == 'S') < 0
			) {
				// title 선택한 정보가 없습니다.\
				// message 삭제 할 데이터를 선택해 주세요.
				this.$showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000418') });
				return;
			}

			this.$showMessage({
				type: 'confirm',
				message: getMessage_('SWCC000108'),
				buttons: [{ title: 'Ok', clickFn: this.remove }]
			});
		}
	},
	created() {
		// console.log('@@@@@@@@@@@@@@@@', this.gridMsgID, this.gridMsgLocs, this.gridMsgTypes);
		this.dicMsgManagementCols[2].options = this.gridMsgID;
		this.dicMsgManagementCols[3].options = this.gridMsgLocs;
		this.dicMsgManagementCols[4].options = this.gridMsgTypes;

		// 초기 Add Data Set 생성
		// this.makeAddDatas();
	}
	// watch: {
	// 	currentTableData(newValue, oldValue) {
	// 		if (newValue != null) {
	// 			newValue.forEach((row) => {
	// 				if (row.tableState == 'I') {
	// 					this.$refs.msgTable.getTable().toggleRowSelection(row);
	// 				}

	// 				if (row.tableState == 'U') {
	// 					newValue.forEach((updateRow) => {
	// 						if (updateRow.msgKey == row.msgKey) {
	// 							this.$refs.msgTable.getTable().toggleRowSelection(updateRow);
	// 						}
	// 					});
	// 				}
	// 			});
	// 		}
	// 	},
	// },
};
</script>

<style></style>
